export default {
  data() {
    return {
      errors: {},
    };
  },

  methods: {
    validateForm(data, rules) {
      this.errors = {};
      for (const field in rules) {
        this._validateField(data[field], field, rules[field]);
      }

      return Object.keys(this.errors).length == 0;
    },

    _validateField(data, field, rule) {
      rule.split('|').forEach(r => {
        this._validateData(data, field, r);
      });
    },

    _validateData(data, field, rule) {
      if (this.errors[field]) return;

      let ruleName = rule.split(':')[0];
      let ruleVars = rule.split(':')[1];
      if (ruleVars) ruleVars = ruleVars.split(',');

      switch (ruleName) {
        case 'required':
          if (data == null || data == undefined) {
            this.errors[field] = 'This field is Required';
          }
          break;

        case 'notempty':
          if (data.trim() == '') {
            this.errors[field] = 'This field cannot be Empty';
          }
          break;

        case 'numeric':
          if (Number(data) == NaN || isNaN(Number(data)) || data.toString().trim() == '') {
            this.errors[field] = 'This field should be a Number';
          }
          break;

        case 'length':
          if (String(data).length < Number(ruleVars[0])) {
            this.errors[field] = 'This field should have ' + ruleVars[0] + ' characters';
          } else if (String(data).length > Number(ruleVars[0])) {
            this.errors[field] = 'This field should have only ' + ruleVars[0] + ' characters';
          }
          break;

        case 'min':
          if (Number(data) < Number(ruleVars[0])) {
            this.errors[field] = `This field should be ${ruleVars[0]} or more`;
          }
          break;

        case 'max':
          if (Number(data) > Number(ruleVars[0])) {
            this.errors[field] = 'This field should be ' + ruleVars[0] + ' or less';
          }
          break;

        case 'date':
          let date = new Date(data);
          if (data == '' || date == undefined || date.toString() == 'Invalid Date' || date == NaN) {
            this.errors[field] = 'This field should be a valid Date';
          }
          break;

        case 'dateempty':
          if (data != undefined) {
            let date = new Date(data);
            if (data == '' || date.toString() == 'Invalid Date' || date == NaN) {
              this.errors[field] = 'This field should be a valid Date';
            }
          }
          break;

        //minDate maxDate
      }
    },
  },
};
